/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * AssignActionStatusDetailsDtoBase
 * auto generated base class for the model AssignActionStatusDetailsDtoModel.
 */
export const AssignActionStatusDetailsDtoModelBase = ModelBase
  .named('AssignActionStatusDetailsDto')
  .props({
    __typename: types.optional(types.literal("AssignActionStatusDetailsDto"), "AssignActionStatusDetailsDto"),
    routeUuids: types.union(types.undefined, types.null, types.array(types.string)),
    eventUuids: types.union(types.undefined, types.null, types.array(types.string)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class AssignActionStatusDetailsDtoModelSelector extends QueryBuilder {
  get routeUuids() { return this.__attr(`routeUuids`) }
  get eventUuids() { return this.__attr(`eventUuids`) }
}
export function selectFromAssignActionStatusDetailsDto() {
  return new AssignActionStatusDetailsDtoModelSelector()
}

export const assignActionStatusDetailsDtoModelPrimitives = selectFromAssignActionStatusDetailsDto().routeUuids.eventUuids
